export default __webpack_public_path__ + "c1cfc71315ce5de198e81efc1e1f72bb.png";